export default {
  frontend: [
    'React',
    'Typescript',
    'Cypress',
    'HTML5',
    'CSS3/SASS',
    'AngularJS',
    'Webpack',
    'Vite'
  ],
  backend: [
    'Python',
    'Node.js',
    'Django',
    'Flask',
    'MySQL/PostgreSQL',
    'AWS (Monitoring)'
  ]
}